<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>Votre Panier</h1>
      </v-col>
    </v-row>

    <v-spacer></v-spacer>

    <v-row>
      <v-col cols="12">
        <Checkout></Checkout>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
  // COMPONENTS
  import Checkout from './Checkout.vue' 

  export default {
    name: 'Show',

    components: { Checkout }
  }
</script>